import React, { Component } from 'react';


class Modal extends Component {
  constructor(props){
    super(props);
    this.state = {
        data: [
           
            {
                id: 1,
                class: "modal1",
                p1: "Find Below the description of 2 Commercial websites:",
                li1:"All Beauty By Sara",
                li2:"SD Brows",
                sub:"I am using the same window modal because of their similarities.",
                p2: "The All Beauty By Sara website, It's a dynamic website, where I used CSS3 for the styles, that includes the use of the box model, positioning, flexbox and media queries for the responsivness. The CSS is organised in modular files within the component's folders targeting directly the component where is linked and one separated index.css for the common styles.",
                p3: "Differently, SD Brows is built with Boostrap for the css and layout",
                p4:" In both websites, I used React.js. As a result, all the website  sections and the website components are well organised in class componests, which will  make them reusable. Therefore, I was able to effectively use JSX, and to demonstrate my understanding of props, state, constructor and hooks. For the navigation within the website I used the npm package react-router-dom.",
                p5:" I have included a dynamic user interaction such the use of a form which required the use of an api that sends a post request to the server, which emails the content directly to the website's owner email address. Moreover, I used WhatsApp api which by clicking in the widget button, it redirect's you to the website's owner WhatsApp chat."
            },
           
              {
                id: 2,
                class: "modal2",
                        
                p2:"Memory Game",
                p3:"This game is built with vanilla JavaScript",
                p4:"The Game is divided in 3 different levels. The first Level: easy, second level: medium, third level difficult. For each two matching cards collect 1 matching point, for each attempt collect 1 attempt. if at the end of the game, More specifically, at the third level, your attempts are more then 65, you have done too many attempts, therefore you have lost the game. If your attempts are equal to 31 you have done Superb!!! if your attempts are in between 31 and 50 you done awesome!!! if your attempts are in between 45 and less then 65 you done not too bad!!!",
               
               
            },
            {
              id: 3,
              class: "modal3",  
              p2:"Guess a Word Game built with Python and SQL",
              p3:"The first thing that shows is a menu with four options:" ,
              li1:"login User", 
              li2:"Login Admin",
              li3:"register user", 
              li4:"register admin" ,                
              p4: "If you are a new player, and you want to play, you will need to register as a user, if you want to add or delete words from the database you will need to as register admin where you can enter and delete as many words as you want. Once you have registered make sure you remember your email and password to login. If you enter the the wrong email or password it will tell you to register. If you have correctly logged in it will welcome you with a message: 'Hi username you are logged in'. Successively, it will ask you to choose a language: English or Italian. if you choose italian your game will be on guessing italian words else if english your game will be on guessing english words at the end of the game it will save your game and ask you if you wish to play again",
            }
        ]
    }
  }
    render() {
      
        return (
          <div className="modal">
          <div className="description">
          <div className="modal-close">
          <i className="fa fa-close tf-close"></i>
            {this.state.data.map(data => (
             
              
           <div className={data.class}>
            <p className="modal-title">
             {data.p1}
              <ul>
                <li>{data.li1}</li>
                <li>{data.li2}</li>
              </ul>
              {data.sub}
              </p>
               
              <p className="it-sp-modal">
              {data.p2}
             </p>
            
            <p className="it-sp-modal">
            {data.p3}
            <ul className='modal3'>
                <li>{data.li1}</li>
                <li>{data.li2}</li>
                <li>{data.li3}</li>
                <li>{data.li4}</li>
              </ul>
            </p>
            <p className="it-sp-modal">
            {data.p4}
            </p>
            <p className="it-sp-modal">
            {data.p5}
            </p>
            </div>
       
            ))}
            </div>
            </div>
          </div>
        );
    }
}

export default Modal;
